import CustomModal from '../../modals';
import { removeIntegrationThunk } from '../../../redux/thunks/integration';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

/**
 * @heading1: DeletePipelineModal
 * @paragraph: A modal component for confirming the deletion of a pipeline.
 * Displays a warning message and provides options to cancel or confirm the deletion.
 * @param: {boolean} open - Determines whether the modal is open.
 * @param: {function} onClose - Function to handle the modal close action.
 */

const RemoveIntegrationModal = ({ open, onClose, type }: { open: boolean; onClose: () => void, type: 'calendar' | 'email' | 'meet' | 'twilio' | 'stripe' }) => {
    /**
     * @heading3: Variables
     * @ol:
     * dispatch: {AppDispatch} - The Redux dispatch function to trigger actions.
     * loaders/selectedPipeline: An object containing the details from the Redux store.
     */
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const { loaders } = useSelector((state: RootState) => state.integration);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const modalTitle = 'To completely remove your connected calendar, Follow these steps:';

    /**
     * @heading3: Functions
     * @heaidng4: Handles the deletion of the pipeline.
     * @paragraph: Dispatches the removeIntegrationThunk to perform the deletion.
     */
    const removeIntegrationHandler = async () => {
        try {
            await dispatch(removeIntegrationThunk({
                type,
                client_id: id && (currentUser?.role === 'client') ? 0 : id ? parseInt(id as string, 10) : 0,
                paramId: id
            })).unwrap();
            // Close the modal after successful deletion
            onClose();
        } catch (e) {
            // Catch Errors
        }
    };

    return <CustomModal open={open} handleClose={loaders.isDeleting ? () => null : onClose} isError={true} title={modalTitle}>
        <ul>
            <li><Typography>Navigate to your <a>Google account settings</a></Typography></li>
            <li><Typography>Navigate through Sign in & Security &gt; Connected apps & sites &gt; Apps connected to your account</Typography></li>
            <li><Typography>Remove the Gonzy app</Typography></li>
        </ul>
        {/* Action buttons */}
        <Box display="flex" gap={2} mt={2}>
            <Button variant="outlined" color="error" onClick={onClose} fullWidth disabled={loaders.isDeleting}>
                Cancel
            </Button>
            <Button type="submit" variant="contained" color="error" onClick={removeIntegrationHandler} fullWidth disabled={loaders.isDeleting}>
                {loaders.isDeleting ? 'Removing...' : 'Proceed'}
            </Button>
        </Box>
    </CustomModal>;
};

export default RemoveIntegrationModal;